// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7b3085e5","749":"80be734f","903":"de8b0c2e"}[chunkId] + ".chunk.js";
};